import { LeafSelect } from "./select.component.js";
customElements.define("leaf-select", LeafSelect);
export {
  LeafSelect
};
//# sourceMappingURL=select.js.map
